import React, { useEffect, useState } from "react";
import { Circles } from "react-loader-spinner";
import { AdminService } from "../../services";
import { injectModels } from "../../redux/injectModels";
const parse = require("html-react-parser");

const WellbeingServices = () => {
  const [loading, setLoading] = useState(false);
  const [country, setCountry] = useState("");
  const [
    managerialUkNational,
    setManagerialUkNational,
  ] = useState("");
  const [
    managerialUkInterNational,
    setManagerialUkInterNational,
  ] = useState("");
  const [
    debtAdvisoryUkNational,
    setDebtAdvisoryUkNational,
  ] = useState("");
  const [
    debtAdvisoryUkInterNational,
    setDebtAdvisoryUkInterNational,
  ] = useState("");
  const [
    wellnessCounselingUkNational,
    setWellnessCounsellingUkNational,
  ] = useState("");
  const [
    wellnessCounselingUkInterNational,
    setWellnessCounsellingUkInterNational,
  ] = useState("");

  const [
    managerialIreNational,
    setManagerialIreNational,
  ] = useState("");
  const [
    managerialIreInterNational,
    setManagerialIreInterNational,
  ] = useState("");
  const [
    debtAdvisoryIreNational,
    setDebtAdvisoryIreNational,
  ] = useState("");
  const [
    debtAdvisoryIreInterNational,
    setDebtAdvisoryIreInterNational,
  ] = useState("");
  const [
    wellnessCounselingIreNational,
    setWellnessCounsellingIreNational,
  ] = useState("");
  const [
    wellnessCounselingIreInterNational,
    setWellnessCounsellingIreInterNational,
  ] = useState("");

  const user_id = localStorage.getItem("user_id");

  // Fetch content
  useEffect(() => {
    (async () => {
      setLoading(true);
      const response = await AdminService.getAllContents();
      if (response) {
        response.forEach((item) => {
          if (item.page_name === "support-number-Managerial-UK-National")
            setManagerialUkNational(item.page_content);
          if (
            item.page_name === "support-number-Legal-Debt-Advisory-UK-National"
          )
            setDebtAdvisoryUkNational(item.page_content);
          if (
            item.page_name === "support-number-Wellness-Counselling-UK-National"
          )
            setWellnessCounsellingUkNational(item.page_content);

          if (item.page_name === "support-number-Managerial-UK-International")
            setManagerialUkInterNational(item.page_content);
          if (
            item.page_name ===
            "support-number-Legal-Debt-Advisory-UK-International"
          )
            setDebtAdvisoryUkInterNational(item.page_content);
          if (
            item.page_name ===
            "support-number-Wellness-Counselling-UK-International"
          )
            setWellnessCounsellingUkInterNational(item.page_content);

          if (item.page_name === "support-number-Managerial-Ireland-National")
            setManagerialIreNational(item.page_content);
          if (
            item.page_name ===
            "support-number-Legal-Debt-Advisory-Ireland-National"
          )
            setDebtAdvisoryIreNational(item.page_content);
          if (
            item.page_name ===
            "support-number-Wellness-Counselling-Ireland-National"
          )
            setWellnessCounsellingIreNational(item.page_content);

          if (
            item.page_name === "support-number-Managerial-Ireland-International"
          )
            setManagerialIreInterNational(item.page_content);
          if (
            item.page_name ===
            "support-number-Legal-Debt-Advisory-Ireland-International"
          )
            setDebtAdvisoryIreInterNational(item.page_content);
          if (
            item.page_name ===
            "support-number-Wellness-Counselling-Ireland-International"
          )
            setWellnessCounsellingIreInterNational(item.page_content);
        });
      }
      setLoading(false);
    })();
  }, []);

  // Fetch user country
  useEffect(() => {
    (async () => {
      const response = await AdminService.getUserDetails(user_id);
      setCountry(response.country);
    })();
  }, []);

  return (
    <>
      {loading && (
        <div className="spinner">
          <div className="loader">
            <Circles height="110" width="110" color="#FFF" ariaLabel="loading" />
          </div>
        </div>
      )}

      <section className="stre-appo">
        <div className="container">
          <div className="row justify-content-center mt-0 mt-md-4">
            {/* Header */}
            <div className="card n-card brdr-blue-left mb-3">
              <label>
                Welcome to your Gewardz Health Employee Assistance Program
              </label>
            </div>

            {/* Subheader */}
            <div className="row">
              <div className="col-md-12 mb-4">
                <div className="appoitment-box bl align-items-center brdr-none">
                  <div className="appb-content well">
                    <div className="row">
                      <div className="col-md-7 d-flex align-items-center">
                        <div className="gp-content">
                          <p className="m-6">
                            Your comprehensive well-being support.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Info Section */}
            <div className="row">
              <div className="col-md-12 mb-4">
                <div className="appoitment-box bl align-items-center brdr-none">
                  <div className="appb-content well">
                    <div className="row">
                      <div className="col-md-7 d-flex align-items-center">
                        <div className="gp-content-service">
                          <h1 className="m-6">
                            Included in the service, all available via our
                            confidential telephone service is:
                          </h1>
                          <ul>
                            <li>24/7 assistance through secure video and phone</li>
                            <li>Counselling</li>
                            <li>Work-life solutions</li>
                            <li>Wellness resources</li>
                            <li>Management and crisis support</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* 3 Tiles */}
            <div className="col-xxl-4 col-lg-4 col-md-6 apt">
              <div className="appoitment-box dr">
                <div className="appb-icon">
                  <i className="fa-solid fa-notes-medical"></i>
                </div>
                <div className="appb-content fith">
                  <div className="appcb">
                    <h3>Wellness Counselling Service</h3>
                    <p>
                      Click on the number below to arrange an appointment.
                      Be assured that all calls are treated in strict confidence.
                    </p>
                  </div>

                  {country && (country === "EU" || country === "IR") ? (
                    <div className="appb-links-no">
                      <h6>Ireland/EU:</h6>
                      <ul>
                        <li>
                          <span><i className="fa-solid fa-phone"></i> National :</span>
                          <strong>{parse(wellnessCounselingIreNational)}</strong>
                        </li>
                        <li>
                          <span><i className="fa-solid fa-phone"></i> INT :</span>
                          <strong>{parse(wellnessCounselingIreInterNational)}</strong>
                        </li>
                      </ul>
                    </div>
                  ) : (
                    <div className="appb-links-no">
                      <h6>UK:</h6>
                      <ul>
                        <li>
                          <span><i className="fa-solid fa-phone"></i> National :</span>
                          <strong>{parse(wellnessCounselingUkNational)}</strong>
                        </li>
                        <li>
                          <span><i className="fa-solid fa-phone"></i> INT :</span>
                          <strong>{parse(wellnessCounselingUkInterNational)}</strong>
                        </li>
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="col-xxl-4 col-lg-4 col-md-6 apt">
              <div className="appoitment-box bl">
                <div className="appb-icon">
                  <i className="fa-solid fa-suitcase-medical"></i>
                </div>
                <div className="appb-content fith">
                  <div className="appcb">
                    <h3>Managerial Support</h3>
                    <p>
                      Click on the number below to arrange an appointment.
                      Be assured that all calls are treated in strict confidence.
                    </p>
                  </div>

                  {country && (country === "EU" || country === "IR") ? (
                    <div className="appb-links-no">
                      <h6>Ireland/EU:</h6>
                      <ul>
                        <li>
                          <span><i className="fa-solid fa-phone"></i> National :</span>
                          <strong>{parse(managerialIreNational)}</strong>
                        </li>
                        <li>
                          <span><i className="fa-solid fa-phone"></i> INT :</span>
                          <strong>{parse(managerialIreInterNational)}</strong>
                        </li>
                      </ul>
                    </div>
                  ) : (
                    <div className="appb-links-no">
                      <h6>UK:</h6>
                      <ul>
                        <li>
                          <span><i className="fa-solid fa-phone"></i> National :</span>
                          <strong>{parse(managerialUkNational)}</strong>
                        </li>
                        <li>
                          <span><i className="fa-solid fa-phone"></i> INT :</span>
                          <strong>{parse(managerialUkInterNational)}</strong>
                        </li>
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="col-xxl-4 col-lg-4 col-md-6 apt">
              <div className="appoitment-box dr">
                <div className="appb-icon">
                  <i className="fa-solid fa-scale-balanced"></i>
                </div>
                <div className="appb-content fith">
                  <div className="appcb">
                    <h3>Legal and Debt Advisory Services</h3>
                    <p>
                      Click on the number below to arrange an appointment.
                      Be assured that all calls are treated in strict confidence.
                    </p>
                  </div>

                  {country && (country === "EU" || country === "IR") ? (
                    <div className="appb-links-no">
                      <h6>Ireland/EU:</h6>
                      <ul>
                        <li>
                          <span><i className="fa-solid fa-phone"></i> National :</span>
                          <strong>{parse(debtAdvisoryIreNational)}</strong>
                        </li>
                        <li>
                          <span><i className="fa-solid fa-phone"></i> INT :</span>
                          <strong>{parse(debtAdvisoryIreInterNational)}</strong>
                        </li>
                      </ul>
                    </div>
                  ) : (
                    <div className="appb-links-no">
                      <h6>UK:</h6>
                      <ul>
                        <li>
                          <span><i className="fa-solid fa-phone"></i> National :</span>
                          <strong>{parse(debtAdvisoryUkNational)}</strong>
                        </li>
                        <li>
                          <span><i className="fa-solid fa-phone"></i> INT :</span>
                          <strong>{parse(debtAdvisoryUkInterNational)}</strong>
                        </li>
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default injectModels(["auth"])(WellbeingServices);
